import React, { Component } from 'react';
import _ from 'underscore';

import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import RegisterWarehouseUser from 'components/modules/settings/RegisterWarehouseUser';
import Container from '../../v2/container';
import AdminUsersList from './AdminUsersList';
import RegisterDriver from './RegisterDriver';
import RegisterShipper from './RegisterShipper';
import RegisterCarrier from './RegisterCarrier';
import RegisterVendor from './RegisterVendor';
import RegisterConsignee from './RegisterConsignee';

import VerticalNav from '../../v2/navs/VerticalNav';
import BulkRegisterUsers from './BulkRegisterUsers';

const navItems = _.sortBy(
  [
    {
      text: 'Admin',
      component: <AdminUsersList />,
      slug: 'admin',
      localizationSlug: 'ADMIN',
    },
    {
      text: 'Driver',
      component: <RegisterDriver />,
      slug: 'register_driver',
      localizationSlug: 'DRIVER',
    },
    {
      text: 'Shipper',
      component: <RegisterShipper />,
      slug: 'register_shipper',
      localizationSlug: 'SHIPPER',
    },
    {
      text: 'Carrier',
      component: <RegisterCarrier />,
      slug: 'register_carrier',
      localizationSlug: 'CARRIER',
    },
    {
      text: 'Vendor',
      component: <RegisterVendor />,
      slug: 'register_vendor',
      localizationSlug: 'VENDOR',
      count: 1,
    },
    {
      text: 'Consignee',
      component: <RegisterConsignee />,
      slug: 'register_consignee',
      localizationSlug: 'CONSIGNEE',
      count: 1,
    },
    {
      text: 'Warehouse User',
      component: <RegisterWarehouseUser />,
      slug: 'register_warehouse_user',
      localizationSlug: 'WAREHOUSE_USER',
    },
    {
      text: 'Bulk Register Users',
      component: <BulkRegisterUsers />,
      slug: 'bulk_register_users',
      localizationSlug: 'BULK_REGISTER_USERS',
    },
  ],
  'text',
);

class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activePage: 'admin',
    };
  }

  isActive(slug) {
    if (this.state.activePage === slug) {
      return true;
    }
    return false;
  }

  getActiveComponent() {
    const { activePage } = this.state;
    return navItems.find((n) => n.slug === activePage).component;
  }

  handleNavItemClick = (activePage) => () => {
    this.setState({ activePage });
  };

  getNavItems = (slug = '') => {
    return [];
  };

  render() {
    const { t } = this.props;
    return (
      <Container>
        <div className="grid sm:grid-cols-12 gap-8 mt-10">
          <div className="col-span-2">
            <VerticalNav>
              {navItems.map((navItem) => (
                <AuthorizationWrapper
                  excludedRegions={this.getNavItems(navItem.slug)}
                >
                  <VerticalNav.NavItem
                    key={navItem.slug}
                    onClick={this.handleNavItemClick(navItem.slug)}
                    active={this.isActive(navItem.slug)}
                    title={titleize(
                      t(navItem.localizationSlug, { count: navItem.count }),
                    )}
                  >
                    {titleize(
                      t(navItem.localizationSlug, { count: navItem.count }),
                    )}
                  </VerticalNav.NavItem>
                </AuthorizationWrapper>
              ))}
            </VerticalNav>
          </div>
          <div className="col-span-10">{this.getActiveComponent()}</div>
        </div>
      </Container>
    );
  }
}

export default withTranslation()(Settings);
